export default function CheckBox({className, children, ...rest}) {
    return (
        <div className="flex items-center text-black">
            <input {...rest} className={`${className} form-checkbox`}/>{children}
        </div>
    );
}